import { FC } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamTypeBreakdownMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamTypeBreakdownMetric | null;
}

export const TeamTypeBreakdownChart: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const chartData = [...data.data]
    .sort((a, b) => b.count - a.count)
    .slice(0, 8)
    .map((d) => ({ type: d.type, count: d.count, pct: d.pct }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        layout="vertical"
        data={chartData}
        margin={{ top: 4, right: 40, left: 4, bottom: 0 }}
      >
        <CartesianGrid {...chartGridProps} vertical horizontal={false} />
        <XAxis type="number" tick={chartAxisTick} allowDecimals={false} />
        <YAxis dataKey="type" type="category" width={100} tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v, _, props) => [`${v} (${props.payload.pct}%)`, 'Infortuni']}
        />
        <Bar dataKey="count" fill="var(--c-text-0)" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
